import {
  ComponentInstance,
  ComponentInstanceCollection,
  OrchestrationComponentInstanceCollection,
  TransformationComponentInstanceCollection
} from 'job-lib/types/Job'

import { getComponentLabel } from './getComponentLabel'

export const generateUniqueName = (
  name: string,
  components:
    | OrchestrationComponentInstanceCollection
    | TransformationComponentInstanceCollection
    | ComponentInstanceCollection
): string => {
  const allNames: Record<string, boolean> = {}

  Object.entries(components).forEach(
    ([id, component]: [string, ComponentInstance]) => {
      allNames[getComponentLabel(component)] = true
    }
  )

  if (!allNames[name]) {
    return name
  }

  let count = 2

  while (allNames[`${name} ${count}`]) {
    count++
  }

  return `${name} ${count}`
}
